<app-mic-volume-ui *ngIf="render$ | async" (close)="onClose()"></app-mic-volume-ui>
